module.exports = __webpack_public_path__ + "img/web_warning.4a131c72.svg";